import { useAdmin } from "@/context/AdminContext";

// Shows the built-in styled version until the admin changes the text; then shows the saved text.
export const EditableText = ({ k, text, as: Tag = "span", className = "", testId, children }) => {
  const { editing, content, saveContent } = useAdmin();
  const saved = typeof content?.[k] === "string" && content[k].trim() ? content[k] : null;
  if (!editing) {
    if (!saved) return children ?? <Tag className={className} data-testid={testId}>{text}</Tag>;
    return <Tag className={`${className} whitespace-pre-line`} data-testid={testId}>{saved}</Tag>;
  }
  return (
    <Tag contentEditable suppressContentEditableWarning data-testid={testId} title="Click to edit"
      onBlur={(e) => { const t = e.currentTarget.innerText.trim(); if (t && t !== (saved ?? text)) saveContent(k, t); }}
      className={`${className} cursor-text whitespace-pre-line outline-dashed outline-2 outline-offset-4 outline-[#E62314]/60 focus:outline-[#E62314]`}>
      {saved ?? text}
    </Tag>
  );
};
